import { EntityType } from "../../../../../models";
import { EditCreateEntityActions } from "../../../../actions/EditCreateEntityActions";
import { ErrorActions } from "../../../../flux/Error/ErrorActions";
import { appNavigator } from "../../../../routes";

export class ShowCreateDivisionCommand
{
    private editActions = new EditCreateEntityActions();
    private errorActions = new ErrorActions();
    
    constructor(private upsertErrorDispatchToken: string)
    {
    }
    
    execute = () => {
        this.editActions.rejectDraft(EntityType.Division);
        this.errorActions.clearError(this.upsertErrorDispatchToken);
        appNavigator.goToAddNewEntityTab(EntityType.Division);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Division/commands/ShowCreateDivisionCommand.ts